import axiosInstance from '@/api/axiosInstance';
import { FetchCoursesParams, FetchCoursesResponse } from './types';

/**
 * Fetch courses with pagination and filtering
 * GET /api/learning-center/courses
 */
export const fetchCourses = async (
  params?: FetchCoursesParams
): Promise<FetchCoursesResponse> => {
  try {
    const response = await axiosInstance.get<FetchCoursesResponse>(
      '/api/learning-center/courses',
      { params }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching courses:', error);
    throw error;
  }
};
